var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirConditioner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.275 23H39.726V25H8.275V23ZM42 9.812C42 7.697 40.258 6 38.145 6H9.811C7.697 6 6 7.697 6 9.812V20H42V9.812ZM41.978 20H6V21.074C6 21.378 6.034 21.688 6.105 22H41.863C41.937 21.69 41.977 21.379 41.977 21.074L41.978 20Z",
    fill: "#EE8003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.855 25.095L8.248 22.233C8.088 21.912 8 21.567 8 21.263V20H6V21.263C6 21.881 6.159 22.526 6.482 23.169L8.12 26.088C8.808 27.268 10.088 28 11.462 28L33 28.001V26.001L11.462 26C10.787 26 10.183 25.656 9.855 25.095ZM40 20V21.263C40 21.567 39.912 21.912 39.774 22.191L38.152 25.081C37.836 25.622 37.172 26.001 36.537 26.001H33V28.001H36.537C37.891 28.001 39.202 27.251 39.889 26.074L41.541 23.126C41.842 22.522 42 21.879 42 21.263V20H40Z",
    fill: "#EE8003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.016 10H35V19H33.016V10Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6223 13.0833L30.6241 11.3708L38.3927 15.9149L37.3909 17.6275L29.6223 13.0833Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5956 17.5975L29.6113 15.8749L37.4255 11.4097L38.4098 13.1323L30.5956 17.5975Z",
    fill: "#F5F5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirConditioner);
export default __webpack_public_path__ + "static/media/air-conditioner.f76d3f8df080b83d78b3305654f2bec4.svg";
export { ForwardRef as ReactComponent };